// extracted by mini-css-extract-plugin
export default {"container":"suggest_idea_container__6GhKW","areas_container":"suggest_idea_areas_container__gxdyt"};